module.exports = __webpack_public_path__ + "img/stamp.188f350d.svg";